import { SET_GROUPS, CLEAR_GROUPS } from "../actions/types";

const initialState = {};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_GROUPS:
      return { groups: payload };

    case CLEAR_GROUPS:
      return { groups: [] };

    default:
      return state;
  }
}
